/* eslint-disable prettier/prettier */
import React, {
  forwardRef,
  Ref,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import Button from '../Button';
import Loading from '../Loading';
import Paginacao from '../Paginacao';
import ProcedimentoCadastroPagina from '../ProcedimentoCadastro';

import Modal from '../Modal';

import { formatPrice } from '../../utils/funcoes';

import { IFormBusca } from '../../pages/Procedimento';
import { IPerfil } from '../../hooks/perfil';
import { IOption } from '../SelectSync';
import getResponseErrors from '../../utils/getResponseErrors';
import { IProcedimento, useProcedimento } from '../../hooks/procedimentos';

export interface IPaginacao {
  termoBusca: IFormBusca;
  limite: number;
  pagina: number;
}

// export interface IProcedimento {
//   ProCodigo: number;
//   ProPerCodigo?: number;
//   ProNome: string;
//   ProCodigoAlvaro: string;
//   ProCor: string;
//   ProIcone: string;
//   ProValor: number;
//   ProDuracao: number;
//   ProRetorno: number;
//   ProLimite: number;
//   ProValorPlano: number;
//   ProCarencia: number;
//   ProValorPlano2: number;
//   ProValorPlanoEmpresarial: number;
//   ProAtivo: boolean;
//   ProFavorito: boolean;
//   ProValorCobrado: number;
//   perfil?: IPerfil;

//   valorFormatado?: string;
//   valorCartao?: string;
//   valorCarencia?: string;
//   ativoFormatado?: string;
// }

// export interface RefObject {
//   addProcedimento(
//     dadosProcedimento: IProcedimento,
//     perf: IOption | undefined,
//     proCodigo: number | undefined,
//   ): Promise<boolean>;
// }
type Props = {
  dados?: IFormBusca;
};

const ListaProcedimentos: React.FC<Props> = ({ dados }: Props) => {
  const {
    deleteProcedimento,
    buscaProcedimentos,
    totalRegistros,
    procedimentos,
    loading,
  } = useProcedimento();
  const [showModalCadastro, setShowModalCadastro] = useState(false);
  const { addToast } = useToast();
  const [paginacao, setPaginacao] = useState<IPaginacao | undefined>(undefined);
  // const [loading, setLoading] = useState(false);
  // const [totalRegistros, setTotalRegistros] = useState<number | undefined>(
  //   undefined,
  // );
  // const [procedimentos, setProcedimentos] = useState<IProcedimento[]>([]);

  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState<
    IProcedimento | undefined
  >(undefined);

  useEffect(() => {
    setPaginacao({
      termoBusca: dados || {
        nome: '',
        perfil: '',
        situacao: '',
        online: '',
        telemedicina: '',
      },
      pagina: 1,
      limite: 20,
    });
  }, [dados]);

  useEffect(() => {
    async function buscaProcedimentosApi(): Promise<void> {
      if (paginacao) await buscaProcedimentos(paginacao);
    }
    buscaProcedimentosApi();
  }, [paginacao, buscaProcedimentos]);

  // useEffect(() => {
  //   async function buscaProcedimentos(): Promise<void> {
  //     if (paginacao) {
  //       try {
  //         setLoading(true);
  //         const { nome, perfil, situacao } = paginacao.termoBusca;
  //         let query = '';
  //         if (nome !== '') query = `&ProNome=${nome}`;
  //         if (perfil !== '') query = `${query}&ProPerCodigo=${perfil}`;
  //         if (situacao !== '') query = `${query}&ProAtivo=${situacao}`;

  //         const response = await api.get(
  //           `/procedimentos?pagina=${paginacao.pagina}&limite=${paginacao.limite}${query}`,
  //         );

  //         const procedimentosApi: IProcedimento[] = response.data[0];

  //         const prodedimentosFormatado = procedimentosApi.map(proc => {
  //           return {
  //             ...proc,
  //             valorFormatado: formatPrice(proc.ProValor),
  //             valorCartao: formatPrice(proc.ProValorPlano),
  //             valorCarencia: formatPrice(proc.ProValorPlano2),
  //             ativoFormatado: proc.ProAtivo ? 'Sim' : 'Não',
  //           };
  //         });

  //         setTotalRegistros(
  //           response.data[1] === 0 ? undefined : response.data[1],
  //         );

  //         setProcedimentos(prodedimentosFormatado);
  //       } catch (error) {
  //         const mensagemErro = getResponseErrors(error);
  //         addToast({
  //           title: 'Não foi possível buscar procedimentos',
  //           type: 'error',
  //           description: mensagemErro,
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   }
  //   if (paginacao) buscaProcedimentos();
  // }, [paginacao, addToast]);

  // const deleteProcedimento = useCallback(
  //   async (codigo: number) => {
  //     setLoading(true);
  //     try {
  //       await api.delete(`/procedimentos/${codigo}`);
  //       setProcedimentos(procedimentosState =>
  //         procedimentosState?.filter(pro => pro.ProCodigo !== codigo),
  //       );
  //     } catch (error) {
  //       const mensagemErro = getResponseErrors(error);
  //       addToast({
  //         title: 'Não foi deletar registro',
  //         type: 'error',
  //         description: mensagemErro,
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [addToast],
  // );

  // const addProcedimento = useCallback(
  //   async (
  //     dadosProcedimento: IProcedimento,
  //     perf: IOption | undefined,
  //     proCodigo: number | undefined,
  //   ): Promise<boolean> => {
  //     let response;
  //     setLoading(true);
  //     let retorno = false;
  //     try {
  //       if (proCodigo) {
  //         response = await api.put<IProcedimento>(
  //           `/procedimentos/${proCodigo}`,
  //           dadosProcedimento,
  //         );
  //       } else {
  //         response = await api.post<IProcedimento>(
  //           '/procedimentos',
  //           dadosProcedimento,
  //         );
  //       }

  //       const retornoProcedimento: IProcedimento = {
  //         ...response.data,
  //         valorFormatado: formatPrice(dadosProcedimento.ProValor),
  //         valorCartao: formatPrice(dadosProcedimento.ProValorPlano),
  //         valorCarencia: formatPrice(dadosProcedimento.ProValorPlano2),
  //         ativoFormatado: dadosProcedimento.ProAtivo ? 'Sim' : 'Não',
  //         ProPerCodigo: Number(perf?.value),
  //         perfil: {
  //           PerCodigo: Number(perf?.value),
  //           PerNome: perf?.label || '',
  //           PerAtivo: true,
  //           PerTipo: 1,
  //         },
  //       };

  //       setProcedimentos(state => {
  //         return state
  //           ? [retornoProcedimento].concat(
  //               state.filter(
  //                 p => p.ProCodigo !== retornoProcedimento.ProCodigo,
  //               ),
  //             )
  //           : [retornoProcedimento];
  //       });

  //       addToast({ title: 'Procedimento salvo', type: 'success' });
  //       retorno = true;
  //     } catch (error) {
  //       const mensagemErro = getResponseErrors(error);
  //       addToast({
  //         title: 'Não foi possível salvar procedimento',
  //         type: 'error',
  //         description: mensagemErro,
  //       });
  //     } finally {
  //       setLoading(false);
  //     }

  //     setShowModalCadastro(false);
  //     return retorno;
  //   },
  //   [addToast],
  // );

  // useImperativeHandle(ref, () => ({ addProcedimento }));

  const handleProximaPagina = useCallback((page: number) => {
    setPaginacao(state => {
      return state && { ...state, pagina: page };
    });
  }, []);

  const handleDeleteProcedimento = useCallback(
    async (codigo: number) => {
      try {
        await deleteProcedimento(codigo);
        addToast({
          type: 'success',
          title: 'Procedimento excluído',
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);

        addToast({
          type: 'error',
          title: 'Não foi possível excluir o procedimento',
          description: mensagemErro,
        });
      }
    },
    [addToast, deleteProcedimento],
  );

  const handleEditar = useCallback(proc => {
    setProcedimentoSelecionado(proc);
    setShowModalCadastro(true);
  }, []);

  return (
    <>
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Procedimento"
          handleFecharModal={() => setShowModalCadastro(false)}
          large
        >
          <ProcedimentoCadastroPagina
            procedimento={procedimentoSelecionado}
            setShowModal={setShowModalCadastro}
          // addProcedimento={addProcedimento}
          />
        </Modal>
      )}
      {loading && <Loading />}

      {procedimentos ? (
        <>
          <table
            className="table table-hover table-sm table-font-small"
            style={{ borderWidth: '0px' }}
          >
            <tbody>
              <tr className="bg-light" style={{ fontSize: 'Small' }}>
                <th scope="col">Nome</th>
                <th scope="col">Perfil</th>
                <th scope="col">Duracao</th>
                <th scope="col">Retorno</th>
                <th scope="col">Valor</th>
                <th scope="col">Cartão Saude</th>
                <th scope="col">Valor Carencia</th>
                <th scope="col">Ativo</th>
                <th scope="col">&nbsp;</th>
                <th scope="col">&nbsp;</th>
              </tr>
              {procedimentos.map((proc: IProcedimento) => (
                <tr
                  key={proc.ProCodigo}
                  style={{ fontSize: 'Small', height: '30px' }}
                  className={`${!proc.ProAtivo ? 'text-muted' : ''}`}
                  data-id={proc.ProCodigo}
                >
                  <td>{proc.ProNome}</td>
                  <td>{proc.perfil?.PerNome}</td>
                  <td style={{ width: '80px' }}>{proc.ProDuracao}</td>
                  <td style={{ width: '80px' }}>{proc.ProRetorno}</td>
                  <td style={{ width: '70px' }}>{proc.valorFormatado}</td>
                  <td style={{ width: '100px' }}>{proc.valorCartao}</td>
                  <td style={{ width: '100px' }}>{proc.valorCarencia}</td>
                  <td style={{ width: '60px' }}>{proc.ativoFormatado}</td>
                  <td className="p-0" style={{ width: '40px' }}>
                    <Button
                      type="button"
                      variant="primary-outline"
                      className="py-0"
                      title={proc.ProCodigo.toString() || ''}
                      onClick={() => handleEditar(proc)}
                    >
                      <FaPencilAlt />
                    </Button>
                  </td>

                  <td className="p-0" style={{ width: '40px' }}>
                    {/* // onClick="if (!window.confirm('Tem certetza que deseja
        excluir este Procedimento?')) return false;" */}
                    <Button
                      type="button"
                      variant="secondary-outline"
                      className="py-0"
                      title={proc.ProCodigo.toString() || ''}
                      onClick={() => {
                        handleDeleteProcedimento(proc.ProCodigo);
                      }}
                    >
                      <FaTrashAlt />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Paginacao
            limitePagina={paginacao?.limite || 15}
            paginasVizinhas={2}
            totalRegistros={totalRegistros}
            paginaInicio={paginacao?.pagina}
            handleProximaPagina={handleProximaPagina}
          />
        </>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '250px' }}
        >
          <h5>Pesquise procedimentos pelo Nome, Perfil e/ou Situação</h5>
        </div>
      )}
    </>
  );
};

export default ListaProcedimentos;
